<button class="dropdown-outline-button" attr.data-cy="{{command.title}}"
        mat-button
        [ngClass]="command.fieldValues['Css']" (click)="executeCommand(command)" [disabled]="command.isDisabled">
  <i class="fas fa-layer-group"></i>
  <span [matTooltip]="command.tooltip && command.tooltip.length>0 ? command.tooltip : ''"
        [matTooltipDisabled]="false">
          {{command.title}}
        </span>
  <i class="fas fa-caret-down"></i>
</button>
